import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { getLatestMessage } from "redux-flash";
import { Field, reduxForm } from "redux-form";
import { TextField } from "redux-form-material-ui";
import Button from "material-ui/Button";
import { CircularProgress } from "material-ui/Progress";

import CenteredForm from "../utils/form/CenteredForm";
import { required } from "../utils/form/formValidation";

import { passwordChangeRequest } from "./actions";

import styles from "./PasswordChange.scss";

class PasswordChange extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    passwordChangeRequest: PropTypes.func.isRequired,
    "password-change": PropTypes.shape({
      requesting: PropTypes.bool.isRequired,
      successful: PropTypes.bool.isRequired,
    }).isRequired,
    login: PropTypes.shape({
      authData: PropTypes.shape({
        id: PropTypes.string.isRequired,
        userId: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    snackbarMessage: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  submit = (values) => {
    const accessToken = this.props.login.authData.id;

    this.props.passwordChangeRequest({ ...values, accessToken });
  };
  render() {
    const {
      handleSubmit,
      "password-change": { requesting, successful },
      snackbarMessage,
    } = this.props;

    return (
      <div>
        <br />
        <br />
        <CenteredForm
          handleOnSubmit={handleSubmit(this.submit)}
          snackbarMessage={snackbarMessage}
        >
          <h4 style={{ textAlign: "center" }}>Changez votre mot de passe</h4>
          <br />
          <div className="mb2">
            <Field
              name="password"
              type="password"
              placeholder="Nouveau mot de passe"
              label="Nouveau mot de passe"
              component={TextField}
              validate={[required]}
              fullWidth
            />
          </div>
          <div className="mb3">
            <Field
              name="passwordCheck"
              type="password"
              placeholder="Confirmation"
              label="Confirmation"
              component={TextField}
              validate={[required]}
              fullWidth
            />
          </div>
          {!successful && (
            <Button
              type={requesting ? "" : "submit"}
              variant="raised"
              color="secondary"
              fullWidth
            >
              {!requesting && !successful && "Réinitialiser"}
              {requesting && <CircularProgress className={styles.requesting} />}
            </Button>
          )}
          {successful && (
            <Link to="/login" replace>
              <Button variant="raised" color="secondary" fullWidth>
                Continuer
              </Button>
            </Link>
          )}
        </CenteredForm>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  "password-change": state["password-change"],
  login: state.login,
  snackbarMessage: getLatestMessage(state) || {},
});

const ConnectedPasswordChange = connect(mapStateToProps, {
  passwordChangeRequest,
})(PasswordChange);

export default reduxForm({
  form: "password-Change",
})(ConnectedPasswordChange);



// WEBPACK FOOTER //
// ./src/pages/password-change/PasswordChange.jsx